export const RUPEES_SYMBOL = "₹";
export const SUCCESS = "SUCCESS";
export const FAILURE = "FAILURE";

export const OTP_RESEND_TIME = 60;

export const RUPEES = "RUPEES";
export const PERCENTAGE = "PERCENTAGE";

export const STATUS_CODE_200 = 200;
export const UNAUTHORIZED = 401;
export const UNAUTHORIZED_MESSAGE = "Unauthorized";
export const STATUS_OK = "OK";

export const FLAT = "FLAT";
export const SLAB = "SLAB";

export const PENDING = "PENDING";
export const REJECTED = "REJECTED";
export const APPROVED = "APPROVED";
export const INACTIVE = "INACTIVE";
export const ACTIVE = "ACTIVE";
export const RNCPENDING = "RNCPENDING";
export const RNCAPPROVED = "RNCAPPROVED";
export const RNCREJECTED = "RNCREJECTED";
export const RNCREJECT = "RNCREJECT";

export const APPROVE = "APPROVE";
export const REJECT = "REJECT";
export const DEACTIVATE = "DEACTIVATE";
export const ACTIVATE = "ACTIVATE";

export const ADMIN = "ADMIN";
export const ADMIN_USER = "ADMIN USER";
export const RESELLER = "RESELLER";
export const CLIENT = "CLIENT";
export const SALES = "SALES";
export const OPERATIONS = "OPERATIONS";
export const SUPPORT = "SUPPORT";
export const FINANCE = "FINANCE";
export const RNC = "RISK AND COMPLIANCE";

export const TRANSACTION_CREDITED = "CREDITED";
export const TRANSACTION_CREDIT = "CREDIT";
export const TRANSACTION_FAILED = "FAIL";
export const TRASACTION_FAILURE = "FAILURE";
export const TRANSACTION_FAIL = "FAILED";
export const TRANSACTION_PENDING = "INITIATED";
export const TRANSACTION_DEBITED = "DEBITED";
export const TRANSACTION_DEBIT = "DEBIT";
export const TRANSACTION_REFUND = "REFUND";
export const TRANSACTION_REJECTED = "REJECTED";
export const TRANSACTION_DEEMED = "DEEMED";
export const TRANSACTION_RETURNED = "RETURNED";
export const TRANSACTION_REVERSED = "REVERSED";
export const CREDIT_CONFIRMATION = "CREDIT_CONFIRMATION";

//ACLS

//dashboard
export const DASHBOARD_ACL = "Dashboard";
export const TRANSACTION_COUNT_ACL = "Transaction_Count";
export const TRANSACTION_VOLUME_ACL = "Transaction_Volume";
export const TRANSACTION_SETTLEMENT_ACL = "Transaction_Settlement";
export const DASHBOARD_APPROVAL_ACL = "Dashboard_Approval";
export const DEACTIVATE_APPROVAL_ACL = "Dashboard_Deactivate_Approval";
export const USER_COUNT_ACL = "Users_Count";
export const USER_COUNT_ACL_NEW = "User_Count";
export const RECENT_TRANSACTION_ACL = "Recent_Transaction";
export const DASHBOARD_DOWNLOAD_TRANSACTION_REPORTS =
  "Dashboard_Download_Transaction_Reports";
export const DASHBOARD_DOWNLOAD_SETTLEMENT_REPORTS =
  "Dashboard_Download_Settlement_Reports";
//client
export const CLIENTS_ACL = "Client";
export const CLIENTS_ALL_ACL = "Client_All";
export const CLIENTS_PAYIN_ACL = "Client_Payin";
export const CLIENTS_PAYOUT_ACL = "Client_Payout";
export const CLIENTS_VAN_ACL = "Client_Van";
export const CLIENTS_VAN_UPI_ACL = "Client_Van_Upi";
export const CLIENTS_VIEWMORE_ACL = "Client_View_More";
export const CLIENTS_DEACTIVATE_ACCOUNT_ACL = "Client_Deactivate_Account";
export const CLIENTS_ADD_ACL = "Add_Client";
export const CLIENT_DOWNLOAD_ACL = "Download_Client";
export const CLIENT_FILTER_ACL = "Client_Filter";
export const CLIENT_EDIT_ACL = "Client_Edit";
export const CLIENT_EDIT_SUB_ACL = "edit_Acl";
// transaction
export const TRANSACTION_ACL = "Transaction";
export const TRANSACTION_ALL_ACL = "Transaction_All";
export const TRANSACTION_PAYIN_ACL = "Transaction_Payin";
export const TRANSACTION_PAYOUT_ACL = "Transaction_Payout";
export const TRANSACTION_VAN_ACL = "TRANSACTION_VAN";
export const TRANSACTION_PREFUND_ACL = "Transaction_Prefund";
export const TRANSACTION_DOWNLOAD_REPORT_ACL = "Transaction_Download_Report";
export const TRANSACTION_FILTER_ACL = "Transaction_flter";
export const TRANSACTION_REFUND_ACL = "Transaction_Refund";
export const TRANSACTION_FAILED_ACL = "Transaction_Failed";

//Reseller
export const RESELLER_ACL = "Reseller";
export const RESELLER_ADD_ACL = "Reseller_Add";
export const RESELLER_FILTER_ACL = "Reseller_Filter";
export const RESELLER_VIEWMORE_ACL = "Reseller_View_More";
export const RESELLER_EDIT_ACL = "Reseller_Edit";
export const RESELLER_DEACTIVATE_ACL = "Reseller_Deactivate";
//Commission list
export const COMMISSION_LIST_ACL = "Commission_List";
export const COMMISSION_DOWNLOAD_ACL = "Commission_Report";
export const COMMISSION_ALL_ACL = "Commission_All";
export const COMMISSION_PAYIN_ACL = "Commission_Payin";
export const COMMISSION_PAYOUT_ACL = "Commission_Payout";
export const COMMISSION_REPORT_ACL = "Commission_Report";
export const COMMISSION_FILTER_ACL = "Commission_Filter";
//Role Management
export const ROLE_MANAGEMENT_ACL = "Role_Management";
export const ROLE_MANAGEMENT_ACL_OLD = "Role Management";
export const ROLE_ADD_ACL = "Role_Management_Add";
export const ROLE_ViewMore_ACL = "Role_Management_View_More";
export const ROLE_Edit_ACL = "Role_Management_Edit";
export const ROLE_Deactivate_ACL = "Role_Management_Deactivate";

//Approval
export const APPROVAL_ACL = "Approval";
export const APPROVAL_PENDING_ACL = "Approval_Pending";
export const APPROVAL_APPROVED_ACL = "Approval_Approved";
export const APPROVAL_REJECTED_ACL = "Approval_Rejected";
export const APPROVAL_DEACTIVATED_ACL = "Approval_Deactivated";
export const APPROVAL_FILTER_ACL = "Approval_Filter";
export const APPROVAL_LIST = "Approval_List";
export const RNC_APPROVE_ACTION = "RNC_APPROVE_ACTION";
export const PREFUND_APPROVE_ACTION = "PREFUND_APPROVAL_ACTION";

//Finance
export const FINANCE_CENTER_ACL = "Finance_Center";

//Api Doc
export const API_DOC_ACL = "Api_Doc";

//Settlement
export const SETTLEMENT_ACL = "Settlement";
export const SETTLEMENT_DOWNLOAD_ACL = "Settlement_Download_Report";
export const FINANCE_SETTLEMENT_ACL = "Finance_Settlement";
export const FINANCE_SETTLEMENT_DOWNLOAD_ACL = "Settlement_Download_Report";
export const FINANCE_REVENUE_DOWNLOAD_ACL = "Finance_Revenue_Report";
export const FINANCE_REVENUE_ACL = "Finance_Revenue";
export const FINANCE_TRANSFER_ACL = "Finance_Transfer";
export const SETTLEMENT_APPROVE_ACL = "settlement_approve_action";
export const BULK_SETTLEMENT_UPLOAD = "Bulk_Upload_Settlement";

// Client settlement
export const CLIENT_SETTLEMENT = "Client_Settlement";

export const BULK_UPLOAD = "Bulk_Upload";

//Service type

export const PAYIN_SERVICE = "payin";
export const PAYOUT_SERVICE = "payout";
export const VAN_SERVICE = "van";
export const VAN_UPI = "van-upi";

//VAN
export const VAN_ACL = "Van";
export const VAN_CLIENT_HASH_ID = "Van";

//Van dashboard
export const VAN_TRANSACTION_VOLUME = "Van_Transaction_Volume";
export const VAN_TRANSACTION_COUNT = "Van_Transaction_Count";
export const VAN_TRANSACTION_RATE = "Transaction_Rate";

//van Customers list
export const VAN_CUSTOMER_LIST = "Customer_List";
export const VAN_CUSTOMER_DOWNLOAD = "Customer_Download";

//van Transaction
export const VAN_TRANSACTION_DOWNLOAD = "Transaction_Download";
export const VAN_TRANSACTION_LIST = "Transaction_List";

//Voucher
export const VOUCHER_TRANSACTION_LIST = "Transaction_Voucher";

//ADD SERVICE
export const ADD_SERVICE_ACL = "AddService";
export const TRANSACTION_LIMIT_EDIT = "TRANSACTION_LIMIT_EDIT";

//Risk Management
export const RISK_MANAGEMENT = "risk_management";
export const CUSTOMER_STATUS_EDIT = "Status_Edit";
export const CUSTOMER_EDIT = "Customer_Edit";
export const BULK_ENTRY = "Bulk_Entry";
export const SINGLE_ENTRY = "Single_Entry";
export const RISK_MANAGEMENT_LIST = "List";

//van customers
export const VAN_CUSTOMERS = "Van_Customers";
export const CUSTOMER_DOWNLOAD_REPORT = "Download_Report";
export const CUSTOMER_LIST = "List";

//Coupon service
export const COUPON_SERVICE = "Coupon";
//Download
export const TRANSACTION_INITIATED_MESSAGE =
  "Transaction report generation initiated";

//Settlement CYCLE constants
export const SETTLEMENT_INSTANT = "instant";
export const SETTLEMENT_CYCLES = "cycles";
export const SETTLEMENT_HOURLY = "hourly";
export const SETTLEMENT_TPLUSONE = "t+1";
export const SETTLEMENT_MANUAL = "manual";

export const CHARGE_BACK_ACL = "add_chargeback";
